/**
 * @Author: 申勇(kevin Kaslana)
 * @Date: 2024/5/13
 * @FilePath: src/plugins
 * @Description:
 * Copyright (c) 2024 by 申勇(kevin Kaslana), All Rights Reserved.
 */

export function getSource(){
  let htmlText
  let xhr = new XMLHttpRequest();

  let domain = ''
  if (window.location.hostname.endsWith('.ruijie.com')) {
    domain = '.ruijie.com'
  }

  let url = `https://www${domain}`

  if (window._env_.ENV !== 'pro') {
    url = `https://www-uat${domain}`
  }

  //建立连接
  xhr.open("get",url + '/api/front-service/getHead',false)
  //参数1：请求的方式  post  get
  //参数2：url地址
  //参数3：是否异步  布尔值，默认为true，若为false，则为同步;

  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  //设置请求头信息  post方式
  xhr.send();
  htmlText = xhr.responseText;
  let str = htmlText;
  let num=str.indexOf("if (blog)")
  let strs=str.slice(0, num) + "console.log($('#movePartners'));" + str.slice(num)
  let strss=strs.replaceAll('function () {    isLogin','window).load(function(){isLogin')
  return strss.replaceAll('/login/?r=',`${url}/login/?r=`)
}
export function getFoot(){
  let htmlText
  let xhr = new XMLHttpRequest();

  let domain = ''
  if (window.location.hostname.endsWith('.ruijie.com')) {
    domain = '.ruijie.com'
  }


  let url = `https://www${domain}`

  if (window._env_.ENV !== 'pro') {
    url = `https://www-uat${domain}`
  }

  //建立连接
  xhr.open("get",url + '/api/front-service/getFooter',false)
  //参数1：请求的方式  post  get
  //参数2：url地址
  //参数3：是否异步  布尔值，默认为true，若为false，则为同步;
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  //设置请求头信息  post方式
  xhr.send();
  htmlText = xhr.responseText;
  return htmlText
}

export default {
  getSource,
  getFoot
};



// WEBPACK FOOTER //
// ./src/plugins/header.js